<script>
  export default {
    name: 'DataTableGoldenMobile',

    props: {
      headers: {
        type: Array,
        required: true,
        default: () => [],
      },
      items: {
        type: Array,
        required: true,
        default: () => [],
      },
      isMobile: {
        type: Boolean,
        required: false,
      },
      hasActions: {
        type: Boolean,
        required: false,
      },
    },

    data: () => ({
      games: {
        838: 'Dragonstone',
        856: 'Dragonstone BG',
        859: 'Mission Amazon',
        862: 'Mission Amazon BG',
        864: 'Max Blast',
        875: "Triple Max Blast",
      },
      spacedOutFields: ['buyIn', 'rank', 'date'],
      currentIndex: 0,
    }),

    computed: {
      headerKeyToText() {
        const obj = {};

        for (const { value, text, iconName } of this.headers) {
          obj[value] = {
            text,
            icon: `/images/svgs/${iconName}.svg`,
          };
        }

        return obj;
      },
    },

    methods: {
      changeIndex(index) {
        this.currentIndex = index;
      },
    },
  };
</script>

<template>
  <div class="v-data-table v-data-table--mobile" @click="$emit('click')">
    <div class="v-data-table__wrapper px-4 h-full" v-if="items.length">
      <carousel-3d
        ref="carousel"
        class="carousel"
        :controls-visible="false"
        :display="1"
        :perspective="200"
        :animation-speed="300"
        @before-slide-change="changeIndex"
      >
        <slide
          v-for="(item, index) in items"
          :key="index"
          :index="index"
          style="background: transparent"
          :class="{ current: index === currentIndex }"
        >
          <div v-for="(_, key) in headerKeyToText" :key="key" class="v-data-table__mobile-row">
            <div class="v-data-table__mobile-row__header my-3">
              <img :src="headerKeyToText[key].icon" alt="header-image" style="width: 35px" />
              <div class="table-row">
                <span class="table-row__text">
                  {{ headerKeyToText[key].text }}
                </span>
                <span class="mx-3 white--text font-weight-800">|</span>
                <span class="table-row__content">
                  <slot :name="`item.${key}`" :item="item">
                    {{ item[key] }}
                  </slot>
                </span>
              </div>
            </div>
          </div>
          <div v-if="hasActions" class="action mt-8 mb-5">
            <slot name="actions" :item="item" />
          </div>
        </slide>
      </carousel-3d>
    </div>
    <div class="paginator">
      <div class="bullet" :class="{ current: currentIndex === 0 }"></div>
      <div class="bullet" :class="{ current: currentIndex !== 0 && currentIndex !== items.length - 1 }"></div>
      <div class="bullet" :class="{ current: currentIndex === items.length - 1 }"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .paginator {
    position: absolute;
    bottom: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 6px;
    height: 20px;
  }

  .bullet {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: white;
    transition: all 0.3s ease-in-out;

    &.current {
      background-color: var(--v-gold-base);
      width: 15px;
      height: 15px;
    }
  }

  .v-data-table--mobile {
    height: 50vh;
  }

  .carousel {
    width: 100%;
    height: 100% !important;

    &::v-deep {
      .carousel-3d-slider,
      .carousel-3d-slide {
        width: 100% !important;
        height: 91% !important;
        overflow-y: auto;
        border: unset;
      }
    }
  }

  .v-data-table__mobile-row__header {
    display: flex;
    align-items: center;
    gap: 20px;
    width: 100%;

    .table-row {
      width: 100%;
      display: flex;
      flex-grow: 1;
      align-items: center;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        top: -5px;
        width: 100%;
        height: 1px;
        background: var(--v-gold-base);
      }

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        width: 100%;
        height: 1px;
        background: var(--v-gold-base);
      }

      &__text {
        white-space: nowrap;
        text-transform: uppercase;
        font-size: 16px;
        font-weight: 800;
        color: var(--v-gold-base);
      }

      &__content {
        font-size: 16px;
        font-weight: 800;
        color: white;
      }
    }
  }
</style>
